import { FilePlus, Flag, BarChart3, Users, MessageSquareText } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { copy } from '@/lib/copy'

export interface AdminSection {
  to: string
  title: string
  description: string
  icon: LucideIcon
  testId: string
}

export const adminSections: AdminSection[] = [
  {
    to: '/admin/articles/create',
    title: copy.admin.createArticleTitle,
    description: copy.admin.createArticleCardDescription,
    icon: FilePlus,
    testId: 'admin-nav-create-article',
  },
  {
    to: '/admin/feedback',
    title: copy.admin.feedbackTitle,
    description: copy.admin.feedbackCardDescription,
    icon: MessageSquareText,
    testId: 'admin-nav-feedback',
  },
  {
    to: '/admin/flags',
    title: copy.admin.flagsTitle,
    description: copy.admin.flagsCardDescription,
    icon: Flag,
    testId: 'admin-nav-feature-flags',
  },
  {
    to: '/admin/metrics',
    title: copy.admin.metricsTitle,
    description: copy.admin.metricsCardDescription,
    icon: BarChart3,
    testId: 'admin-nav-metrics',
  },
  {
    to: '/admin/users',
    title: copy.admin.usersTitle,
    description: copy.admin.usersCardDescription,
    icon: Users,
    testId: 'admin-nav-users',
  },
]
